const PREFIX = 'chat_widget';

/** ID visiteur (numérique depuis l’API) stocké en string. */
export function getVisitorId(siteToken: string): number | null {
  try {
    const raw = localStorage.getItem(`${PREFIX}_visitor_${siteToken}`);
    if (raw == null) return null;
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? null : n;
  } catch {
    return null;
  }
}

export function setVisitorId(siteToken: string, visitorId: number): void {
  try {
    localStorage.setItem(`${PREFIX}_visitor_${siteToken}`, String(visitorId));
  } catch {
    // ignore
  }
}

export function clearVisitorId(siteToken: string): void {
  try {
    localStorage.removeItem(`${PREFIX}_visitor_${siteToken}`);
  } catch {
    // ignore
  }
}
